import React from 'react';
import { graphql, PageProps } from 'gatsby';

// 
import { useTinaEditor } from '@brz-utils/tina';
import { GenericPageHead } from './generic.head';
import GenericPageRender from './generic.render';

// Types
import { PageDataModel } from './types';
import { PageModels } from '@brz-types/page.models';


const GenericPageTemplate = (props: PageProps<PageModels.DataModel<PageDataModel>>) => {    
    const tina = props.data.page.tina;

    // console.log(props);
    
    const { data } = useTinaEditor({
        data: tina.data,
        query: tina.query,
        variables: tina.variables
    });
    
    return <GenericPageRender data={data} pageProps={{ location: props.location, params: props.params }} />
};


export default GenericPageTemplate;

export const PageQuery = graphql`
    query($id: String) {
        page: mdx(id: { eq: $id }) {
            tina
            id
        }
    }
`;

export const Head = GenericPageHead; 